__turbopack_context__.v({
  "about": "style-module-scss-module__L2g5IG__about",
  "about-inner-html": "style-module-scss-module__L2g5IG__about-inner-html",
  "agent-picture": "style-module-scss-module__L2g5IG__agent-picture",
  "agent-picture-exp-logo": "style-module-scss-module__L2g5IG__agent-picture-exp-logo",
  "agent-picture-initials": "style-module-scss-module__L2g5IG__agent-picture-initials",
  "associations": "style-module-scss-module__L2g5IG__associations",
  "associations-badge-image": "style-module-scss-module__L2g5IG__associations-badge-image",
  "associations-content": "style-module-scss-module__L2g5IG__associations-content",
  "associations-content-paragraph": "style-module-scss-module__L2g5IG__associations-content-paragraph",
  "associations-heading": "style-module-scss-module__L2g5IG__associations-heading",
  "back-arrow": "style-module-scss-module__L2g5IG__back-arrow",
  "bio": "style-module-scss-module__L2g5IG__bio",
  "bio-container": "style-module-scss-module__L2g5IG__bio-container",
  "bio-content": "style-module-scss-module__L2g5IG__bio-content",
  "bio-content-heading": "style-module-scss-module__L2g5IG__bio-content-heading",
  "bio-heading": "style-module-scss-module__L2g5IG__bio-heading",
  "bio-small-margin": "style-module-scss-module__L2g5IG__bio-small-margin",
  "component": "style-module-scss-module__L2g5IG__component",
  "content": "style-module-scss-module__L2g5IG__content",
  "copy": "style-module-scss-module__L2g5IG__copy",
  "cta": "style-module-scss-module__L2g5IG__cta",
  "custom-button-style": "style-module-scss-module__L2g5IG__custom-button-style",
  "is-commercial": "style-module-scss-module__L2g5IG__is-commercial",
  "learn-more": "style-module-scss-module__L2g5IG__learn-more",
  "learn-more-no-bg": "style-module-scss-module__L2g5IG__learn-more-no-bg",
  "license-number": "style-module-scss-module__L2g5IG__license-number",
  "main-info": "style-module-scss-module__L2g5IG__main-info",
  "personal-contact": "style-module-scss-module__L2g5IG__personal-contact",
  "social-media": "style-module-scss-module__L2g5IG__social-media",
  "top-back-button": "style-module-scss-module__L2g5IG__top-back-button",
  "twitter-button": "style-module-scss-module__L2g5IG__twitter-button",
  "youtube-button": "style-module-scss-module__L2g5IG__youtube-button",
});
